{
  "lang": "nl",
  "theme": "template-toggle-clean",
  "plugins": [
    "a11y-describedby",
    "a11y-user-detect",
    "array._groupby",
    "asterisk",
    "auto-next-when-only-radio",
    "bb-input-wrap-and-unit",
    "broadcast-fields",
    "broadcast-fields--receiver",
    "case-filter-extra",
    "case-template",
    "chapters",
    "close-caseslist",
    "feedback-local",
    "grid-tabs",
    "grids-to-cards-toggle",
    "grids-to-graphs",
    "has-no-next",
    "headings",
    "history",
    "info-inline",
    "markdown-it",
    "markdown-it-converter",
    "md-labels",
    "md5",
    "model-filter",
    "modelinfo",
    "modelitem",
    "mustache",
    "non-indenting-jumplist",
    "previews",
    "progressbar",
    "questionlabelgroup-ng",
    "reset-password",
    "show-server-side-validation",
    "skip",
    "style-grid",
    "tabs",
    "wrap-table"
  ],
  "arbitrary": {
    "headings": {
      "baseLevel": "2"
    },
    "core": {
      "skipNumButtons": true,
      "wrapAllSingleLiners": true
    },
    "previews": {
      "showChanges": true
    }
  },
  "template": {
    "less": {
      "post": [
        "vars-bb-theme.less",
        "sizes.less"
      ]
    },
    "logo": "custom/template-toggle-clean/conf/images/logo-bb.png",
    "favicon": "images/favicon-bb.png",
    "companyname": "Berkeley Bridge",
    "companywebsite": "https://www.berkeleybridge.com/",
    "themeColor": "#182a64",
    "breakpoint": "1025",
    "readonly-prop": "disabled"
  },
  "legacy": false,
  "fonts": [
    "roboto-v27"
  ]
}
